export const convertGS1 = (barcode: string, prefix: number) => {
  return `(${barcode.slice(0, prefix)})${barcode.slice(prefix)}`
}
